import { useState } from "react";
import "./styles/cis.css";
import InternalError from "../components/generales/InternalError";
import { lang } from '../components/generales/traduction'
import PanelCis from "../components/cis-components/PanelCis";
import PanelCalendario from "../components/excepciones-components/PanelCalendario";
import PanelExcepciones from "../components/excepciones-components/PanelExcepciones";
const Portafolio = ({handleShowPopup,pageSelected, server, dataGlobals,languaje,mode }) => {
  const [listSelected, setListSelected] = useState(1);
  const [internalError,setInternalError]=useState(false)
  const hadleChangeList = (e) => {
    setListSelected(e);
  };
  function renderAdminComponent() {
      try {
          switch (pageSelected) {
              case "mantto-excepciones":
                  return <PanelExcepciones handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} setInternalError={setInternalError} server={server} />;
              case "mantto-calendar":
                  return <PanelCalendario handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
              // case "noti-user":
              //     return <NotifiAdmin languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
              // case "noti-tec":
              //     return <NotifiTech languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
              default:
                  return <></>;
          }
      } catch (error) {
          console.error('Error rendering component:', error);
          return <div>{lang[languaje['msgErrorPagina']]}</div>;
      }
  }
  return (
    <div className={"main-cis"+mode}>
       {(internalError)?
            <InternalError/>
            :renderAdminComponent()}
       {/* <PanelExcepciones languaje={languaje} mode={mode} setInternalError={setInternalError} server={server} /> */}
    </div>
  );
};

export default Portafolio;
